/* Aarvie storefront behaviour. No libraries.
   Drawers (menu, bag, filters), search panel with live results, bag updates without page reloads, wishlist kept in
   the visitor's browser, product sizes / Custom Fit / gallery, collection filters and sorting, size-table units. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const routes = (window.Aarvie && window.Aarvie.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  const money = (cents) => {
    const value = Number(cents) / 100;
    const whole = Number.isInteger(value);
    return '₹' + value.toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  };

  /* ---------- Drawers and overlay ---------- */

  const overlay = document.createElement('div');
  overlay.className = 'overlay';
  document.body.appendChild(overlay);
  let openDrawer = null;
  let lastFocus = null;

  function open(drawer) {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) close(openDrawer, false);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    openDrawer = drawer;
    const focusable = drawer.querySelector('[data-autofocus], button, a, input');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 60);
  }

  function close(drawer = openDrawer, restore = true) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    openDrawer = null;
    if (restore && lastFocus) lastFocus.focus({ preventScroll: true });
  }

  overlay.addEventListener('click', () => close());
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if ($('.lightbox.is-open')) return closeLightbox();
    if ($('.modal.is-open')) return closeModal();
    if ($('.search-panel.is-open')) return toggleSearch(false);
    close();
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      const target = document.getElementById(opener.dataset.open);
      if (target && target.classList.contains('modal')) openModal(target);
      else open(target);
      return;
    }
    if (e.target.closest('[data-close]')) {
      e.preventDefault();
      if (e.target.closest('.modal')) closeModal();
      else close();
    }
  });

  /* Mobile menu: sub panels slide in from the right */
  document.addEventListener('click', (e) => {
    const next = e.target.closest('[data-panel-open]');
    if (next) {
      e.preventDefault();
      const panel = document.getElementById(next.dataset.panelOpen);
      if (panel) panel.classList.add('is-open');
    }
    const back = e.target.closest('[data-panel-back]');
    if (back) {
      e.preventDefault();
      back.closest('.menu-panel').classList.remove('is-open');
    }
  });

  /* ---------- Modal (size guide) ---------- */

  function openModal(modal) {
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const btn = modal.querySelector('.modal__close');
    if (btn) setTimeout(() => btn.focus(), 60);
  }

  function closeModal() {
    const modal = $('.modal.is-open');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!openDrawer) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- Header over the home hero: white once scrolled, hovered or searching ---------- */

  function refreshHeader() {
    const header = $('[data-header]');
    if (!header || !document.body.classList.contains('template-index')) return;
    const panel = $('[data-search-panel]');
    const solid = window.scrollY > 10 || header.matches(':hover') || (panel && panel.classList.contains('is-open'));
    header.classList.toggle('is-solid', solid);
  }

  window.addEventListener('scroll', refreshHeader, { passive: true });
  document.addEventListener('mouseover', (e) => {
    if (e.target.closest('[data-header]')) refreshHeader();
  });
  document.addEventListener('mouseout', (e) => {
    if (e.target.closest('[data-header]')) requestAnimationFrame(refreshHeader);
  });

  /* ---------- Search panel with live results ---------- */

  const searchPanel = $('[data-search-panel]');

  function toggleSearch(force) {
    if (!searchPanel) return;
    const show = typeof force === 'boolean' ? force : !searchPanel.classList.contains('is-open');
    searchPanel.classList.toggle('is-open', show);
    $$('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(show)));
    refreshHeader();
    if (show) setTimeout(() => $('input[type="search"]', searchPanel).focus(), 80);
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-search-toggle]');
    if (toggle) {
      e.preventDefault();
      close();
      toggleSearch();
    } else if (searchPanel && searchPanel.classList.contains('is-open') && !e.target.closest('[data-search-panel]')) {
      toggleSearch(false);
    }
  });

  if (searchPanel) {
    const input = $('input[type="search"]', searchPanel);
    const results = $('[data-predictive]', searchPanel);
    let timer;
    let controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const url = `${routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4`.replace('//search', '/search');
          const res = await fetch(url, { signal: controller.signal });
          const data = await res.json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          results.innerHTML = items
            .map((p) => {
              const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy" width="64" height="85">` : '<span></span>';
              return `<a class="predictive__item" href="${p.url}">${img}<span><span class="card__title">${p.title}</span><br><span class="predictive__price">${money(Math.round(parseFloat(p.price) * 100))}</span></span></a>`;
            })
            .join('');
        } catch (err) {
          /* aborted or offline: keep the panel as it is */
        }
      }, 220);
    });
  }

  /* ---------- Bag ---------- */

  const cartDrawer = document.getElementById('CartDrawer');

  function setCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.dataset.count = count;
    });
  }

  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer'] && cartDrawer) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('[data-cart-inner]');
      const current = cartDrawer.querySelector('[data-cart-inner]');
      if (fresh && current) current.replaceWith(fresh);
    }
    const page = $('[data-cart-page]');
    if (sections['main-cart'] && page) {
      const doc = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
      const fresh = doc.querySelector('[data-cart-page]');
      if (fresh) page.replaceWith(fresh);
    }
  }

  function cartSectionIds() {
    const ids = ['cart-drawer'];
    const page = $('[data-cart-page]');
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    return ids;
  }

  async function changeLine(key, quantity) {
    const ids = cartSectionIds();
    const res = await fetch(`${routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: ids, sections_url: window.location.pathname }),
    });
    const cart = await res.json();
    if (cart.sections && ids[1]) cart.sections['main-cart'] = cart.sections[ids[1]];
    renderSections(cart.sections);
    setCount(cart.item_count);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (btn) {
      e.preventDefault();
      const line = btn.closest('[data-line]');
      const input = $('input', line);
      const next = Math.max(0, Number(input.value) + Number(btn.dataset.qty));
      input.value = next;
      changeLine(line.dataset.line, next);
      return;
    }
    const remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.closest('[data-line]').dataset.line, 0);
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line] input[type="number"]');
    if (input) changeLine(input.closest('[data-line]').dataset.line, Math.max(0, Number(input.value) || 0));
  });

  // Shiprocket's BUY NOW opens its checkout without submitting the bag form, so save the studio note as it's typed.
  let noteTimer;
  document.addEventListener('input', (e) => {
    const note = e.target.closest('textarea[name="note"]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(`${routes.cart}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value }),
      });
    }, 400);
  });

  async function addToCart(formData) {
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message || 'Could not add to bag');
    renderSections(data.sections);
    const cart = await (await fetch(`${routes.cart}.js`)).json();
    setCount(cart.item_count);
    open(cartDrawer);
    return data;
  }

  /* ---------- Wishlist (stored in this browser) ---------- */

  const WKEY = 'aarvie:wishlist';
  const readWish = () => {
    try {
      return JSON.parse(localStorage.getItem(WKEY)) || [];
    } catch (err) {
      return [];
    }
  };
  const writeWish = (list) => {
    try {
      localStorage.setItem(WKEY, JSON.stringify(list));
    } catch (err) {
      /* storage blocked: the hearts still toggle for this page */
    }
  };

  function paintWish() {
    const list = readWish();
    $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', String(list.includes(b.dataset.wish))));
    $$('[data-wish-count]').forEach((el) => {
      el.textContent = list.length > 0 ? list.length : '';
      el.dataset.count = list.length;
    });
    $$('[data-wish-label]').forEach((el) => {
      const on = list.includes(el.closest('[data-wish]').dataset.wish);
      el.textContent = on ? el.dataset.on : el.dataset.off;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.wish;
    let list = readWish();
    list = list.includes(handle) ? list.filter((h) => h !== handle) : [handle, ...list];
    writeWish(list);
    paintWish();
    const page = btn.closest('[data-wishlist]');
    if (page && !list.includes(handle)) {
      const card = btn.closest('[data-card]');
      if (card) card.remove();
      updateWishPage(page);
    }
  });

  function updateWishPage(page) {
    const count = readWish().length;
    const title = $('[data-wishlist-count]', page);
    if (title) title.textContent = count;
    $('[data-wishlist-empty]', page).hidden = count > 0;
  }

  async function renderWishlist(page) {
    const grid = $('[data-wishlist-grid]', page);
    const list = readWish();
    updateWishPage(page);
    const cards = await Promise.all(
      list.map(async (handle) => {
        try {
          const res = await fetch(`${routes.root}products/${handle}?section_id=wishlist-card`.replace('//products', '/products'));
          if (!res.ok) return null;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          return doc.querySelector('[data-card]');
        } catch (err) {
          return null;
        }
      })
    );
    grid.replaceChildren(...cards.filter(Boolean));
    paintWish();
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-wish-add]');
    if (!form) return;
    e.preventDefault();
    const select = $('select', form);
    const option = select.options[select.selectedIndex];
    if (option && option.dataset.custom === 'true') {
      window.location.href = form.dataset.url + '?variant=' + select.value;
      return;
    }
    const btn = $('button[type="submit"]', form);
    btn.classList.add('is-loading');
    try {
      const fd = new FormData();
      fd.append('id', select.value);
      fd.append('quantity', '1');
      await addToCart(fd);
    } catch (err) {
      alert(err.message);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------- Product ---------- */

  function initProduct(root) {
    const form = $('[data-product-form]', root);
    if (!form) return;
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const idInput = $('input[name="id"]', form);
    const customBox = $('[data-custom-fit]', root);
    const sizeValue = $('[data-size-value]', root);
    const payment = $('[data-payment]', root);
    const addBtn = $('[data-add]', form);
    const addLabel = $('[data-add-label]', form);
    const error = $('[data-form-error]', root);
    const customName = (root.dataset.customOption || 'Custom Fit').toLowerCase();
    const wa = $('[data-wa-enquiry]', root);

    function updateWhatsApp(size) {
      if (!wa) return;
      const text = `Hi Aarvie, I would like to know more about ${wa.dataset.waProduct}${size ? ` (size ${size})` : ''}. ${wa.dataset.waLink}`;
      wa.href = `${wa.dataset.waBase}?text=${encodeURIComponent(text)}`;
    }

    function current() {
      const picked = $$('input[data-option]:checked', root).map((i) => i.value);
      return variants.find((v) => v.options.every((o, i) => o === picked[i]));
    }

    function update() {
      const v = current();
      const picked = $$('input[data-option]:checked', root);
      if (sizeValue) sizeValue.textContent = picked.length ? picked.map((i) => i.value).join(' / ') : '';
      updateWhatsApp(picked.map((i) => i.value).join(' / '));
      if (!v) {
        idInput.value = '';
        return;
      }
      idInput.value = v.id;
      const isCustom = v.options.some((o) => o.toLowerCase() === customName);
      if (customBox) {
        customBox.hidden = !isCustom;
        $$('input, textarea', customBox).forEach((f) => {
          f.disabled = !isCustom;
        });
      }
      /* Buy it now skips the measurement fields, so it hides for Custom Fit */
      if (payment) payment.hidden = isCustom;
      addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? addLabel.dataset.label : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (error) error.textContent = '';
    }

    $$('input[data-option]', root).forEach((i) => i.addEventListener('change', update));
    update();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (error) error.textContent = '';
      if (!idInput.value) {
        if (error) error.textContent = 'Please choose a size.';
        return;
      }
      if (customBox && !customBox.hidden) {
        const missing = $$('[required]', customBox).find((f) => !f.value.trim());
        if (missing) {
          if (error) error.textContent = 'Please add your measurements for a custom fit.';
          missing.focus();
          return;
        }
      }
      addBtn.classList.add('is-loading');
      try {
        await addToCart(new FormData(form));
      } catch (err) {
        if (error) error.textContent = err.message;
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });

    /* Gallery: thumbnails (desktop), swipe with progress dots (tablet/phone), tap to open full screen */
    const slides = $('[data-slides]', root);
    const thumbs = $$('[data-thumb]', root);
    const dots = $$('[data-dot]', root);
    if (slides) {
      const setActive = (i) => {
        thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      };
      thumbs.forEach((t, i) =>
        t.addEventListener('click', () => {
          slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        })
      );
      let raf;
      slides.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => setActive(Math.round(slides.scrollLeft / slides.clientWidth)));
      });
      const lightbox = $('[data-lightbox]', root);
      $$('[data-slide]', slides).forEach((s, i) =>
        s.addEventListener('click', () => {
          if (!lightbox) return;
          lightbox.classList.add('is-open');
          document.body.classList.add('is-locked');
          const track = $('.lightbox__slides', lightbox);
          requestAnimationFrame(() => (track.scrollLeft = track.clientWidth * i));
        })
      );
    }
  }

  function closeLightbox() {
    const lb = $('.lightbox.is-open');
    if (!lb) return;
    lb.classList.remove('is-open');
    if (!openDrawer) document.body.classList.remove('is-locked');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lightbox-close]')) closeLightbox();
  });

  /* ---------- Collection: filters and sorting (on the products of this page) ---------- */

  function initCollection(root) {
    const grid = $('[data-grid]', root);
    if (!grid) return;
    const cards = $$('[data-card]', grid);
    const promo = $('[data-promo]', grid);
    const countEl = $$('[data-count]', root);
    const clearBtns = $$('[data-clear]', root);
    const state = { sort: 'featured' };

    const priceBucket = (cents) => {
      const r = cents / 100;
      if (r < 7000) return 'under-7000';
      if (r <= 10000) return '7000-10000';
      return 'over-10000';
    };

    function selected() {
      const sel = {};
      $$('[data-filter]:checked', root).forEach((i) => {
        (sel[i.dataset.filter] = sel[i.dataset.filter] || new Set()).add(i.value);
      });
      return sel;
    }

    function apply() {
      const sel = selected();
      let shown = 0;
      cards.forEach((c) => {
        const values = { category: c.dataset.category, fabric: c.dataset.fabric, colour: c.dataset.colour, price: priceBucket(Number(c.dataset.price)) };
        const ok = Object.entries(sel).every(([k, set]) => set.has(values[k]));
        c.hidden = !ok;
        if (ok) shown += 1;
      });
      const active = Object.values(sel).reduce((n, s) => n + s.size, 0);
      if (promo) promo.hidden = active > 0;
      countEl.forEach((el) => (el.textContent = shown));
      clearBtns.forEach((b) => (b.hidden = active === 0));
      $$('[data-filter-total]', root).forEach((el) => (el.textContent = active ? `(${active})` : ''));
      $$('[data-filter-count]', root).forEach((el) => {
        const n = (sel[el.dataset.filterCount] || new Set()).size;
        el.textContent = n ? `(${n})` : '';
      });
      const empty = $('[data-empty]', root);
      if (empty) empty.hidden = shown > 0;

      const sorted = [...cards].sort((a, b) => {
        switch (state.sort) {
          case 'price-asc':
            return a.dataset.price - b.dataset.price;
          case 'price-desc':
            return b.dataset.price - a.dataset.price;
          case 'newest':
            return b.dataset.date - a.dataset.date;
          case 'title':
            return a.dataset.title.localeCompare(b.dataset.title);
          default:
            return a.dataset.index - b.dataset.index;
        }
      });
      sorted.forEach((c) => grid.appendChild(c));
      if (promo) grid.appendChild(promo);
      $$('[data-sort]', root).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.sort === state.sort)));
      $$('[data-sort-label]', root).forEach((el) => (el.textContent = $(`[data-sort="${state.sort}"]`, root).textContent));
    }

    /* desktop dropdowns and the phone sheet hold the same checkboxes; keep them in step */
    root.addEventListener('change', (e) => {
      const box = e.target.closest('[data-filter]');
      if (!box) return;
      $$(`[data-filter="${box.dataset.filter}"][value="${CSS.escape(box.value)}"]`, root).forEach((b) => (b.checked = box.checked));
      apply();
    });

    root.addEventListener('click', (e) => {
      const sort = e.target.closest('[data-sort]');
      if (sort) {
        state.sort = sort.dataset.sort;
        apply();
        const dd = sort.closest('.dropdown');
        if (dd) dd.classList.remove('is-open');
      }
      if (e.target.closest('[data-clear]')) {
        $$('[data-filter]', root).forEach((b) => (b.checked = false));
        apply();
      }
    });

    apply();
  }

  /* Dropdowns (filters, sort) */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.dropdown__toggle');
    $$('.dropdown.is-open').forEach((d) => {
      if (!toggle || d !== toggle.closest('.dropdown')) {
        if (!e.target.closest('.dropdown__panel') || !d.contains(e.target)) d.classList.remove('is-open');
      }
    });
    if (toggle) {
      const dd = toggle.closest('.dropdown');
      dd.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(dd.classList.contains('is-open')));
    }
  });

  /* ---------- Carousels ---------- */

  function initCarousel(root) {
    const track = $('[data-track]', root);
    const prev = $('[data-prev]', root);
    const next = $('[data-next]', root);
    if (!track || !prev || !next) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 24 : track.clientWidth);
    const paint = () => {
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', paint, { passive: true });
    paint();
  }

  /* ---------- Size tables: inches / cm ---------- */

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-unit]');
    if (!btn) return;
    const scope = btn.closest('[data-size-guide]') || document;
    const unit = btn.dataset.unit;
    $$('[data-unit]', scope).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unit === unit)));
    $$('[data-in]', scope).forEach((cell) => {
      const inches = parseFloat(cell.dataset.in);
      if (Number.isNaN(inches)) return;
      cell.textContent = unit === 'cm' ? (Math.round(inches * 2.54 * 2) / 2).toString() : cell.dataset.in;
    });
  });

  /* ---------- FAQ: highlight the group in view ---------- */

  function initFaq(root) {
    const links = $$('[data-faq-link]', root);
    if (!links.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id));
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    $$('[data-faq-group]', root).forEach((g) => io.observe(g));
  }

  /* ---------- Reveal on scroll ---------- */

  function initReveal() {
    const items = $$('.reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach((i) => i.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            io.unobserve(en.target);
          }
        }),
      { rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach((i) => io.observe(i));
    watchCards(document);
  }

  /* Product cards rise into place one after another as they come into view (client reference: divyammehta.com).
     Cards that appear together are staggered in page order; cards added later (wishlist, filters) are picked up too. */
  let cardIO = null;
  let firstCards = true;

  function watchCards(scope) {
    if (!document.documentElement.classList.contains('js-reveal')) return;
    if (!('IntersectionObserver' in window)) {
      document.documentElement.classList.remove('js-reveal');
      return;
    }
    if (!cardIO) {
      cardIO = new IntersectionObserver(
        (entries) => {
          const shown = entries
            .filter((en) => en.isIntersecting)
            .map((en) => en.target)
            .sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
          shown.forEach((card, i) => {
            card.style.setProperty('--reveal-delay', `${(firstCards ? 0.2 : 0) + Math.min(i, 10) * 0.08}s`);
            card.classList.add('is-revealed');
            cardIO.unobserve(card);
          });
          if (shown.length) firstCards = false;
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
      );
      new MutationObserver((list) =>
        list.forEach((m) =>
          m.addedNodes.forEach((n) => {
            if (n.nodeType !== 1) return;
            if (n.matches('[data-card]:not(.is-revealed)')) cardIO.observe(n);
            $$('[data-card]:not(.is-revealed)', n).forEach((c) => cardIO.observe(c));
          })
        )
      ).observe(document.body, { childList: true, subtree: true });
    }
    $$('[data-card]:not(.is-revealed)', scope).forEach((c) => cardIO.observe(c));
  }

  /* ---------- Start ---------- */

  function init(root = document) {
    $$('[data-product]', root).forEach(initProduct);
    $$('[data-collection]', root).forEach(initCollection);
    $$('[data-carousel]', root).forEach(initCarousel);
    $$('[data-faq]', root).forEach(initFaq);
    $$('[data-wishlist]', root).forEach(renderWishlist);
    paintWish();
    initReveal();
    refreshHeader();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
